import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { Dispatch } from 'redux';
import type { AppDispatch, RootState } from './configureStore';

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppDispatch = (): Dispatch => useDispatch<AppDispatch>();
